
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.243 1.334a.707.707 0 00-.597.347L3.603 10.48a.445.445 0 00-.056.194l-.213 3.52a.445.445 0 00.69.398l2.927-1.945a.445.445 0 00.139-.148l5.043-8.794a.715.715 0 00-.26-.964L9.61 1.426a.685.685 0 00-.366-.092zm.084.958l1.945 1.126-.598 1.041L8.73 3.334l.598-1.042zm-1.038 1.81l1.94 1.126-3.69 6.437-1.945-1.125 3.695-6.437zM4.39 11.449l1.473.852-1.589 1.056.116-1.908z","fill":"currentColor"}})])
          )
        }
      }
    